import type { Drone, PartType } from '../../../../../types';
import type { UnitSelection } from '../../../hooks/useServiceDraft/types';

// Current effective usage of the drafted service target. Per-unit parts read their
// unit counters; a specific unit reads its own counter, while 'All units' reports
// the worst unit (mirrors getWorstWear). Aggregate parts read the drone usage map.
// Props read the per-prop usages applyServiceRecords attaches (FR-30b); with no
// records applied every prop still sits at the shared aggregate counter.
export const getTargetUsage = ({
    drone,
    partType,
    unitSelection
}: {
    drone: Drone;
    partType: PartType;
    unitSelection: UnitSelection;
}): number => {
    const unitUsages: Partial<Record<PartType, number[]>> = {
        flowMeter: [drone.flowMeter.usage],
        motor: drone.motors.map(motor => motor.usage),
        propSet: drone.propSetUnitUsages ?? drone.motors.map(() => drone.usage.propSet ?? 0),
        pumpSealKit: drone.pumps.map(pump => pump.usage)
    };

    const usages = unitUsages[partType];

    if (!usages) {
        return drone.usage[partType] ?? 0;
    }

    if (unitSelection.kind === 'unit') {
        return usages[unitSelection.unitNumber - 1] ?? 0;
    }

    return usages.reduce((highest, usage) => Math.max(highest, usage), 0);
};
